// Modules
import React, { ReactNode } from 'react'

// Application
import { useCurrentLaboratory } from 'redesign/hooks/useCurrentLaboratory'
import { userPathDetect } from 'utils'

// Components
import { Header } from 'components/Header'
import { CustomSnackbar } from 'redesign/components/molecules/CustomSnackbar'
import { navTheme } from 'theme'
import { ThemeProvider } from '@dasa-health/alma-react'
import { SnackbarProvider } from 'redesign/context/snackbar'
import { useScreenSize } from 'hooks'
import { Aside } from 'components/Aside'
import { EasyAccessContainer } from 'components/EasyAccessContainer'
import { Container, Content, ContainerPage, Text, ContentButton, ButtonLink } from './styles'

interface TemplateContainerProps {
    children: ReactNode
    renderHeader?: boolean
}

declare const OneTrust: OneTrust
interface OneTrust {
    ToggleInfoDisplay?: () => void
}

export const DefaultTemplate = ({ children, renderHeader = false }: TemplateContainerProps) => {
    const { currentLaboratory } = useCurrentLaboratory()
    const { isDesktop } = useScreenSize()
    const { isLoginPage, isLoginWithLinkPage } = userPathDetect()

    const isLogin = isLoginPage || isLoginWithLinkPage
    const showButtons = !isLoginWithLinkPage

    return (
        <SnackbarProvider>
            <Container>
                {isDesktop() && <Aside />}
                <Content>
                    <ContainerPage>
                        {renderHeader && <Header logoAux={currentLaboratory} />}
                        {children}
                    </ContainerPage>
                    {!isDesktop() && isLogin && <EasyAccessContainer showButtons={showButtons} />}
                    {isLogin && (
                        <ContentButton>
                            <Text>Site protegido pelo reCAPTCHA.</Text>
                            <ButtonLink
                                onClick={() => OneTrust?.ToggleInfoDisplay?.()}
                                style={!isDesktop() ? { color: ' #FEFEFE' } : {}}
                            >
                                Confira aqui nossas configurações de cookies.
                            </ButtonLink>
                        </ContentButton>
                    )}
                </Content>
                <ThemeProvider theme={navTheme}>
                    <CustomSnackbar />
                </ThemeProvider>
            </Container>
        </SnackbarProvider>
    )
}
